import { createContext } from 'react'

const metalOrderContext = createContext();

export default metalOrderContext;